// extracted by mini-css-extract-plugin
export var body = "_lj-0";
export var sectionHeader = "_lj-4";
export var shortcutColumns = "_lj-2";
export var shortcutList = "_lj-1";
export var shortcutSection = "_lj-3";